import React from 'react';

export const ProBadge = ({ tier, className = '' }) => {
    if (!tier || tier === 'free') {
        return (
            <span
                className={`inline-flex items-center px-1.5 py-0.5 rounded-md text-[10px] font-bold tracking-wider uppercase bg-secondary text-muted-foreground border border-border ${className}`}
                data-testid="pro-badge-free"
            >
                BASIC
            </span>
        );
    }

    const label = tier === 'pro_unlimited' ? 'PRO' : 'PLUS';
    return (
        <span
            className={`inline-flex items-center px-1.5 py-0.5 rounded-md text-[10px] font-bold tracking-wider uppercase bg-gradient-to-r from-amber-500 to-orange-500 text-white ${className}`}
            data-testid="pro-badge"
        >
            {label}
        </span>
    );
};

export default ProBadge;
